import React from "react";
import { Button, Image } from "react-bootstrap";
import STRINGS from "../../constants/strings";
import { useHistory } from "react-router-dom";
import "./styles.scss";

export default function ThankYou(props) {
  const { isMobile } = props;
  const history = useHistory();
  if (
    !props.location ||
    !props.location.state ||
    props.location.state.isStorePickup === undefined
  ) {
    history.push("/");
    return null;
  } else {
    const { isStorePickup } = props.location.state;
    return (
      <div className="d-flex justify-content-center h-100">
        <div className="text-center mt-5">
          <Image
            src={
              "https://sindhi-website-assets.s3.ap-south-1.amazonaws.com/logo.png"
            }
            className="thank-you-logo-image"
          />
          <h2 className="mt-5 text-weight-bold">
            Thank you for your order! Now sit back and Relax!
          </h2>
          <p
            className={isMobile ? "w-100 p-2" : "w-75"}
            style={{ margin: "auto", fontSize: isMobile ? "3.5vw" : "1.5vw" }}
          >
            {isStorePickup
              ? " We have received your order. We will update you once your order is ready for pickup. Orders received until 6 pm are packed the same day, otherwise the next working day. Order pickups can be delayed during festive season."
              : "We have received your order. We will update you once your order is picked up from our courier partner. Orders received until 3 pm are packed the same day, otherwise the next working day. Deliveries can be delayed during the festive season."}
          </p>
          <ul className="thank-you-list">
            <li>
              We are operational from <strong>Tuesday to Sunday</strong> from
              <strong> 10:30 am to 9:00 pm.</strong>
            </li>
            <li>
              For any query, contact us at 8178474593 or for WhatsApp
              <span className="ml-1">
                <a href="https://wa.me/918178474593">
                  https://wa.me/918178474593
                </a>
              </span>
            </li>
            <li>Please see your order details on your WhatsApp/Email ID.</li>
          </ul>
          <hr />
          <div>
            <Button
              variant="outline-warning"
              className="landing-button"
              onClick={() => props.history.push("/")}
            >
              {STRINGS.BACK_TO_HOMEPAGE}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
